"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreamAlertsRoutes = void 0;
const base_1 = require("../base");
const constants_1 = require("../constants");
/**
 * API routes for stream alerts management
 * Handles monitoring and configuration of stream alert channels
 */
class StreamAlertsRoutes extends base_1.ApiBase {
    /**
     * Get list of channels configured for stream alerts
     * @returns Promise resolving to array of stream alert channels
     * @throws Error if the API request fails
     */
    async getStreamAlertsChannels() {
        return this.apiGet(`${constants_1.ROUTES.STREAM_ALERTS}/channels`);
    }
    /**
     * Add a Twitch channel to stream alerts monitoring
     * @param twitchUsername - The Twitch username to add to stream alerts
     * @returns Promise resolving when the channel is added
     * @throws Error if the API request fails or user is not authenticated
     */
    async addChannelToStreamAlerts(twitchUsername) {
        return this.apiPost(`${constants_1.ROUTES.STREAM_ALERTS}/channels`, {
            channels: [twitchUsername],
        });
    }
    /**
     * Remove a Twitch channel from stream alerts monitoring
     * @param twitchUserId - The Twitch user ID to remove from stream alerts
     * @returns Promise resolving when the channel is removed
     * @throws Error if the API request fails or user is not authenticated
     */
    async removeChannelFromStreamAlerts(twitchUserId) {
        return this.apiDelete(`${constants_1.ROUTES.STREAM_ALERTS}/channels/${twitchUserId}`);
    }
    /**
     * Get current EventSub subscriptions
     * @returns Promise resolving to array of EventSub subscriptions
     */
    async getEventSubSubscriptions() {
        return this.apiGet(`${constants_1.ROUTES.STREAM_ALERTS}/subscriptions`);
    }
    /**
     * Clear all EventSub subscriptions
     * @returns Promise resolving when all subscriptions are cleared
     */
    async clearAllSubscriptions() {
        return this.apiDelete(`${constants_1.ROUTES.STREAM_ALERTS}/subscriptions/all`);
    }
    /**
     * Re-subscribe all currently watched channels
     * @returns Promise resolving with per-channel results
     */
    async resubscribeAllChannels() {
        return this.apiPost(`${constants_1.ROUTES.STREAM_ALERTS}/subscriptions/resubscribe`, {});
    }
}
exports.StreamAlertsRoutes = StreamAlertsRoutes;
//# sourceMappingURL=stream-alerts.js.map